var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechstackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 31.5C0 14.103 14.103 0 31.5 0V0C48.897 0 63 14.103 63 31.5V31.5C63 48.897 48.897 63 31.5 63V63C14.103 63 0 48.897 0 31.5V31.5Z",
    fill: "#D9D9D9",
    fillOpacity: 0.15
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 13,
    width: 24,
    height: 7,
    rx: 3.5,
    fill: "#D9D9D9",
    fillOpacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 23,
    width: 24,
    height: 7,
    rx: 3.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 33,
    width: 24,
    height: 7,
    rx: 3.5,
    fill: "#D9D9D9",
    fillOpacity: 0.25
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 43,
    width: 24,
    height: 7,
    rx: 3.5,
    fill: "#D9D9D9",
    fillOpacity: 0.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 13,
    width: 6,
    height: 7,
    rx: 3,
    fill: "#D9D9D9",
    fillOpacity: 0.15
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 23,
    width: 6,
    height: 7,
    rx: 3,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 33,
    width: 6,
    height: 7,
    rx: 3,
    fill: "#D9D9D9",
    fillOpacity: 0.25
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 43,
    width: 6,
    height: 7,
    rx: 3,
    fill: "#D9D9D9",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechstackIcon);
export default __webpack_public_path__ + "static/media/techstack_icon.919c8027395b54cdc9ef42e9422e9a56.svg";
export { ForwardRef as ReactComponent };